import { render, staticRenderFns } from "./availability-show-type-field.vue?vue&type=template&id=23c727f5&"
import script from "./availability-show-type-field.vue?vue&type=script&lang=js&"
export * from "./availability-show-type-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports